import { IContextState, IContextAction, SET_COMPANY, SET_AVAILABLE_COMPANIES } from "./types";

const initialState: IContextState = {
  companies: [],
};

export function contextReducer(state: IContextState = initialState, action: IContextAction): IContextState {
  switch (action.type) {
    case SET_COMPANY:
      return {
        ...state,
        company: action.payload.company,
      };
    case SET_AVAILABLE_COMPANIES:
      return {
        ...state,
        companies: action.payload.companies || state.companies,
      };
  }
  return state;
}
